export const APP_WATCH_SHARED_DATA = '__WATCH_SHARED_DATA__' as const;
export const APP_MAIN_SCRIPT_TRIGGER = '$$__AC_WATCH_MAIN_TRIGGER_FUNCTION__$$' as const;
